export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.16-1531.29',
  commitId: '602a698a7a199c264d59c2182d3308582d968922',
  commitTime: '2026-03-16T15:31:29.000Z',
});
